/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class Settings extends PageStringSection {
    button_back_label: string = "Labels.lbl_Back";
    pageTitle: string = "Labels.lbl_Settings";
    panelTitle_accountSelfCreation_label: string = "Labels.lbl_AccountSelfCreation";
    panelTitle_authentication_label: string = "Labels.lbl_Authentication";
}
